import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AiRecruiterService {
  private apiUrl = environment.API_BASE;
  private httpOptions = { withCredentials: true };

  constructor(private http: HttpClient) {}

  getOpenRoles(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/api/open-roles`, this.httpOptions);
  }

  getRoleDetail(roleId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}role/${roleId}`, this.httpOptions);
  }

  getIntakeSession(roleId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}api/intake/${roleId}`, this.httpOptions);
  }

  sendIntakeMessage(role: any, messages: { role: string; content: string }[], isResuming: boolean = false): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}api/intake/chat`,
      { role, messages, is_resuming: isResuming },
      this.httpOptions
    );
  }

  saveIntakeSession(roleId: number, messages: { role: string; content: string }[], isComplete: boolean): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}api/intake/save`,
      { role_id: roleId, messages, is_complete: isComplete },
      this.httpOptions
    );
  }

  getRecommendations(roleId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}api/intake/recommend/${roleId}`, this.httpOptions);
  }

  generateRecommendations(roleId: number, role: any, messages: any[], model: string): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}api/intake/recommend`,
      { role_id: roleId, role, messages, model },
      this.httpOptions
    );
  }

  submitFeedback(roleId: number, candidateId: number, status: string, rejectionComment: string = null): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}api/intake/recommend/feedback`,
      { role_id: roleId, candidate_id: candidateId, status, rejection_comment: rejectionComment },
      this.httpOptions
    );
  }
}
